export default __webpack_public_path__ + "static/media/chat.99913e55.png";